// Module
var code = `<div tabindex="-1" class="js-win {{.style_addition_jsWin}}{{!attached && !dockablePanel ? ' detached' : ''}}" {{>windowPart}} on-mousedown="@this.onMouseDown(event)" on-mousemove="@this.onMouseMove(event)" on-contextmenu="@this.onContextMenuOpen(event)" on-keydown="@this.onKeyDown(event)" on-mouseenter="@this.onMouseEnter(event)" on-mouseleave="@this.onMouseLeave(event)" >
    <div class="js-win-tabBar-tab {{.style_addition_header}}" on-dblclick="@this.onHeaderDblClick" on-mousedown="@this.onMouseDown(event,true)">
        <div class="js-text">{{{.headerInnerHTML}}}</div>

        {{#if showHeader}}
            <div class="js-win-tabBar-button-sector">
                {{#if .isAccountLinkShowState}}
                <div class="tab-handle-accLink">
                    <terceraLinkControl linkByAccount="true" selectedLinkValue="{{.accountLinkValue}}" tooltip="{{.accountLinkTooltip}}"  nameOfComponent="accountLink"/>
                </div>
                {{/if}}
                {{#if .isSymbolLinkShow}}
                <div class="tab-handle-symbLink">
                    <terceraLinkControl selectedLinkValue="{{.symbolLinkValue}}" tooltip="{{.symbolLinkTooltip}}" nameOfComponent="symbolLink" />
                </div>
                {{/if}}

                {{#if .showFullscreenModeButton}}
                <terceraButton name="fullscreenBtn" SVG="true" terceraButtonStyle="js-button-fullscreen" on-btnClick="fullscreenModeClick" tooltip="{{.fullscreenModeBtnTooltip}}" />
                {{/if}}

                {{#if .isVisibileViewMoreActionsButton}}
                    <terceraButton name="morePanelActionsBtn" SVG="true" terceraButtonStyle="js-button-view-more-panel-actions" on-btnClick="@this.onViewMoreActionsClick(event)" tooltip="{{.viewMoreActionsBtnTooltip}}" checked="{{isViewMoreMenuOpened}}"/>
                {{/if}}

                <terceraButton name="closeCrossBtn" SVG="true" terceraButtonStyle="js-closeWindowBtn" visible="{{.closeBtnVisible}}" />
            </div>
        {{/if}}
    </div>
    {{#if .isShowExploreTheAppLink}}
        <div class="js-win-exploreTheAppLink">
            {{.exploreTheAppStart}}<a href="{{.exploreTheAppLink}}" target="_self">{{.exploreTheAppLinkPartText}}</a>{{.exploreTheAppEnd}}
        </div>
    {{/if}}
    <div class="js-win-innerContainer {{.style_addition_body}} {{#.withBorderRadius}}js-win-radius{{/}}" style="{{#.showOverflow}}overflow:visible;{{/}}">
        {{{.innerHtml}}}
        {{>bodyPartial}}
        <terceraPanel name="windowPanelBody" />
        <terceraPanel name="quickTableControlContainer"/>
    </div>
    <div class="js-win-tabBar-footer {{.style_addition_footer}}">
        {{>footerPartial}}
    </div>
    {{#if .forbiddenPanel}}
    <div style="top:{{.showHeader ? 32 : 0}}px;"
         class="js-tercera-label js-forbidden-label">
        {{.banText}}
    </div>
    {{/if}}
    {{#.loading}}
    <div class="js-loading-mask">
        <svg>
            <use xlink:href="assets/webdesktop/web-desktop-sprite.svg#loadingSpinner"></use>
        </svg>
    </div>
    {{/}}
    <div class="window-border"></div>
    {{>outScreensPart}}
    {{#if isInFullScreenMode && @shared.mainContext.showForceUpdateScreen}}
        <forceUpdateNotificationScreen />
    {{/if}}
</div>

{{#if .showFullscreenCloud}}
<div intro="cloud" class="js-fullscreen-cloud" {{^.visible}}style="display:none;" {{/}}></div>
{{elseif .showModalMask}}
<div class="js-fullscreen-dark-background"></div>
{{elseif .showCustomFullscreenCloud && .zIndex}}
<div intro="cloud" class="js-fullscreen-cloud" style="z-index: {{.zIndex-1}};" {{^.visible}}style="display:none;" {{/}}></div>
{{/if}}

{{#partial windowPart}}
{{#if !(.dockablePanel)}}{{#.focused}}focused=""{{/}}{{/if}}
{{#if !(.isRelativeStyle)}}style="position: absolute;{{else}}style="position: relative; {{/if}}
{{#.widthInPercent}} width: {{widthInPercent}}%; {{/}}
{{#.heightInPercent}} height: {{heightInPercent}}%; {{/}}
{{#.withOutBorder}} border:0px solid transparent; box-shadow: none; {{/}}
{{#if .dockablePanel}}
{{#.width}}width:{{.width}}px;{{/}}
{{#.height}}height:{{.height}}px;{{/}}
{{#.bottom}}bottom:{{.bottom}}px;{{/}}
{{#.right}}right:{{.right}}px;{{/}}
{{^.visible}}display:none;{{/}}
border:0px solid transparent;
box-shadow: none;
{{else}}
{{>position}}
{{/if}}
{{#if .showFullscreenCloud || .showModalMask}}
z-index:10000001;
{{elseif .isLookup}}
    z-index:1400;
    {{#if !.top}}
    top:0px;
    {{/if}}
{{elseif !(.dockablePanel) && .zIndex}}
z-index:{{.zIndex}};
{{elseif .showCustomFullscreenCloud && .zIndex}}
z-index:{{.zIndex}};
{{/if}}
{{#if .alwaysMiddle}}{{>alwaysMiddlePart}}{{/if}}"
showHeader="{{.showHeader?'1':0}}"
isShowExploreTheAppLink="{{.isShowExploreTheAppLink?'1':'0'}}"
showFooter="{{.showFooter?'1':'0'}}"
showBorder="{{.showBorder?'1':'0'}}"
inDock="{{.dockablePanel?'1':'0'}}"
{{^.resizable}}noResize="1"{{/}}
{{/partial}}`;
// Exports
export default code;